export const environment = 'heroku'
export const BASE_URL = {
    local: 'http://localhost:8000',
    heroku: 'https://spam-ham-classifier-flask-app.herokuapp.com'
}